module.exports = ".refresh-button {\n  margin-top: 10px;\n  margin-bottom: 15px; }\n\n.glyphicon {\n  font-family: inherit; }\n\n.glyphicon:before {\n  font-family: 'Glyphicons Halflings'; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/tasks/task.component.scss
// module id = ./src/app/admin/tasks/task.component.scss
// module chunks = main